"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var AuthorizationProvider_1 = require("../providers/AuthorizationProvider");
var ConfigProvider_1 = require("../providers/ConfigProvider");
var either_1 = require("../utils/either");
var useNoParamsGetJSON_1 = __importDefault(require("./useNoParamsGetJSON"));
var useToken = function () {
    var _a = ConfigProvider_1.useConfig(), authUrl = _a.authUrl, disableAuth = _a.disableAuth;
    var auth = AuthorizationProvider_1.useAuthorization();
    var isSwitchMandate = localStorage.getItem('switchMandateEnable') === 'true';
    var getRedirectLogin = useNoParamsGetJSON_1.default(authUrl + "/RedirectLogin" + (isSwitchMandate ? '?switchMandate=true' : ''));
    var getRedirectLogout = useNoParamsGetJSON_1.default(authUrl + "/RedirectLogout" + ((auth === null || auth === void 0 ? void 0 : auth.samlNameId) ? "?samlNameId=" + auth.samlNameId : '') + " ");
    // const getJSON = useGetJSON(`${authUrl}/JwtLogin`);
    var redirectLogin = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getRedirectLogin()];
                case 1:
                    response = _a.sent();
                    if (either_1.isRight(response)) {
                        window.location.href = response.value;
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getRefreshToken = function () {
        return localStorage.getItem('refreshToken');
    };
    var getToken = function () {
        var tokenString = localStorage.getItem('token');
        if (tokenString) {
            var userToken = JSON.parse(tokenString);
            return userToken;
        }
        return undefined;
    };
    var _b = react_1.useState(getToken()), value = _b[0], setValue = _b[1];
    // const login = async (aifo) => {
    //   const response = await getJSON({ aifo });
    //   if (isRight(response)) {
    //     const jwtToken = JSON.stringify((response as any).value.token);
    //     localStorage.setItem('token', jwtToken);
    //     setValue(jwtToken);
    //   }
    // };
    var logout = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    localStorage.removeItem('token');
                    localStorage.removeItem('refreshToken');
                    localStorage.removeItem('switchMandateEnable');
                    localStorage.clear();
                    setValue(undefined);
                    return [4 /*yield*/, getRedirectLogout()];
                case 1:
                    response = _a.sent();
                    if (either_1.isRight(response)) {
                        window.location.href = response.value;
                        auth === null || auth === void 0 ? void 0 : auth.setSamlNameId(undefined);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var setRefreshToken = function (refreshToken) {
        localStorage.setItem('refreshToken', refreshToken);
    };
    var setToken = function (token) {
        auth === null || auth === void 0 ? void 0 : auth.set(token);
        var jwtToken = JSON.stringify(token);
        localStorage.setItem('token', jwtToken);
        setValue(jwtToken);
    };
    var getDataFromToken = function (tokenValue) {
        var parseValue = tokenValue || value;
        if (parseValue) {
            try {
                return JSON.parse(Buffer.from(parseValue.split('.')[1], 'base64').toString('utf8'));
            }
            catch (error) {
                console.log(error);
            }
        }
    };
    var refresh = function () { return __awaiter(void 0, void 0, void 0, function () {
        var headers, tokenString;
        return __generator(this, function (_a) {
            if (getRefreshToken() && !disableAuth) {
                if (getDataFromToken(getToken()).exp * 1000 < new Date().getTime()) {
                    logout();
                    return [2 /*return*/];
                }
                try {
                    headers = new Headers({ 'Content-Type': 'application/json;' });
                    tokenString = localStorage.getItem('token');
                    if (tokenString)
                        headers.set('Authorization', JSON.parse(tokenString));
                    fetch(authUrl + "/refresh-token", {
                        method: 'POST',
                        body: JSON.stringify({ token: getRefreshToken() }),
                        headers: headers,
                    })
                        .then(function (response) {
                        if (response.ok) {
                            return response.json();
                        }
                        logout();
                        return;
                    })
                        .then(function (result) {
                        if (!result) {
                            logout();
                        }
                        if (result && result.valid && !!result.refreshToken && !!result.jwtToken) {
                            setRefreshToken(result.refreshToken);
                            setToken(result.jwtToken);
                        }
                        else {
                            logout();
                        }
                    });
                }
                catch (ex) {
                    logout();
                    console.log(ex);
                }
            }
            return [2 /*return*/];
        });
    }); };
    return {
        // login,
        getDataFromToken: getDataFromToken,
        refresh: refresh,
        value: value,
        redirectLogin: redirectLogin,
        setRefreshToken: setRefreshToken,
        setToken: setToken,
        logout: logout,
    };
};
exports.default = useToken;
